export function checkEmptyFields(fields: object) {
  const hasEmptyField = Object.values(fields).some((value) => !value);
  if (hasEmptyField) {
    throw new Error('Has empty mandatory field');
  }
}
